import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';

export default {
  async getReasonSettings(_, params) {
    try {
      let url = '/depot/reason_settings?';
      if (params.depot_id) {
        url = `${url}depot_id=${params.depot_id}`;
      }
      if (params.movement) {
        url = `${url}&movement=${params.movement}`;
      }
      if (params.type) {
        url = `${url}&type=${params.type}`;
      }
      if (params.sub_type) {
        url = `${url}&sub_type=${params.sub_type}`;
      }
      const result = await axios.get(url);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
};
